module.exports = __webpack_public_path__ + "static/media/esselunga.9a029c20.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/esselunga.png
// module id = 731
// module chunks = 0